"use client";

import { CitationTool } from "@/components/citation-tool";
import { getFeaturedStyles } from "@/data/citation-styles";

/**
 * Live citation generator embedded on the Dictionary landing page. The tool opens
 * straight on the manual-entry tab preset to the "Dictionary entry" source type (CSL
 * `entry-dictionary`). Users type the word, dictionary name, publisher, and year, and
 * pick any of the 10,834 styles.
 */
export default function DictionaryCitationGeneratorWidget() {
  return (
    <CitationTool
      initialManualType="entry-dictionary"
      initialMode="manual"
      styles={getFeaturedStyles()}
    />
  );
}
